import { render, staticRenderFns } from "./CollaborationChanger.vue?vue&type=template&id=661a6286"
import script from "./CollaborationChanger.vue?vue&type=script&lang=js"
export * from "./CollaborationChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports